import React from 'react'
import { RichText as PrismicRichText } from "prismic-reactjs"
import styled from "styled-components"

import { Element, Text } from "components/shared/base"
import { 
  PrismicHomepageDataBodyTitleAndDescriptionTwoColumnPrimary
} from "types/__generated__/gatsby-graphql"


export type TwoColumnTitleDescriptionProps = PrismicHomepageDataBodyTitleAndDescriptionTwoColumnPrimary

const StyledTitle = styled(Element)`
  a {
    color: ${props => props.theme.colors.textPrimary};
  }
`;

const TwoColumn: React.FC<TwoColumnTitleDescriptionProps> = ({
  description,
  top_border = true,
  title
}): React.ReactElement => {
  return (
    <Element
      as="section"
      pt="100px"
      px="20px"
    >
      <Element
        borderColor="textPrimary"
        borderTop={top_border ? "1px solid" : ""}
        display="grid"
        gridColumnGap="25px"
        gridColumnEnd={["span 12", "span 5"]}
        gridTemplateColumns="repeat(12, 1fr)"
        m="0 auto"
        maxWidth="contentWidth"
        padding={["30px 0", "35px 0 70px"]}
      >
        {title && (
          <StyledTitle
            fontSize={["text.titleMobile", "text.title"]}
            gridColumnEnd={["span 12", "span 5"]}
            lineHeight="primary"
          >
            <PrismicRichText render={title.richText} />
          </StyledTitle>
          
        )}
        {description && (
          <Text
            fontSize={["text.primaryMobile", "text.primary"]}
            lineHeight="primary"
            mt={["25px", "0" ]}
            gridColumnEnd={["span 12", "span 6"]}
            gridColumnStart={["1", "7"]}
          >
            {description}
          </Text>
        )}
      </Element>
    </Element>
  )
}

export default TwoColumn
